var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C9.38 2.5 7.25 4.63 7.25 7.25C7.25 9.82 9.26 11.9 11.88 11.99C11.96 11.98 12.04 11.98 12.1 11.99C12.12 11.99 12.13 11.99 12.15 11.99C12.16 11.99 12.16 11.99 12.17 11.99C14.73 11.9 16.74 9.82 16.75 7.25C16.75 4.63 14.62 2.5 12 2.5Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.08 14.66C14.29 12.8 9.73996 12.8 6.92996 14.66C5.65996 15.5 4.95996 16.65 4.95996 17.88C4.95996 19.11 5.65996 20.25 6.91996 21.09C8.31996 22.03 10.16 22.5 12 22.5C13.84 22.5 15.68 22.03 17.08 21.09C18.34 20.24 19.04 19.1 19.04 17.86C19.03 16.64 18.34 15.49 17.08 14.66Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.37 19.76C11.21 19.76 11.05 19.69 10.93 19.58L9.66999 18.32C9.42999 18.08 9.42999 17.68 9.66999 17.44C9.90999 17.2 10.31 17.2 10.55 17.44L11.37 18.26L13.45 16.18C13.69 15.94 14.09 15.94 14.33 16.18C14.57 16.42 14.57 16.82 14.33 17.06L11.81 19.58C11.69 19.7 11.53 19.76 11.37 19.76Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTick);
export default __webpack_public_path__ + "static/media/profile-tick.e9d77494accb2df4040c28f67b2a858f.svg";
export { ForwardRef as ReactComponent };